import { CostsPrice, Price } from './../../../../erp-common/erp-common.model';
import { ArticleType, ArticleTypeAttribute, AttributeGroupUsage } from './../../../../article-types/article-type.model';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { Component, OnInit, Input } from '@angular/core';
import { AppClientConfigurationService } from '@sdbn/common';

@Component({
  selector: 'app-costsprice-list',
  templateUrl: './costsprice-list.component.html',
  styleUrls: ['./costsprice-list.component.scss']
})
export class CostspriceListComponent implements OnInit {

  priceScale = 2;

  attributes = new Array<ArticleTypeAttribute>();

  vatColumn = 'price-vat';
  taxRateColumn = 'tax-rate';
  columns: string[] = ['source', 'valid-from', 'valid-until', 'price-net', this.taxRateColumn, this.vatColumn, 'reference-date', 'commands'];

  @Input() articleType: ArticleType;

  @Input() hideVatPrices = false;

  @Input() datasource: MatTableDataSource<CostsPrice>;

  @Input() editCostsPriceFunction: (args: any) => any;

  @Input() removeCostsPriceFunction: (args: any) => any;

  constructor(private liveAnnouncer: LiveAnnouncer,
              public cps: AppClientConfigurationService) {

    this.priceScale = this.cps.getPropertyValue('erp.use-three-digit-prices', 'false') === 'true' ? 3 : 2;

  }

  ngOnInit(): void {
    if (this.hideVatPrices) {
      this.columns.splice(this.columns.indexOf(this.vatColumn), 1);
      this.columns.splice(this.columns.indexOf(this.taxRateColumn), 1);
    }
    this.articleType.attributeGroups.filter(group => group.usage === AttributeGroupUsage.COSTSPRICE)
                                    .forEach(group => this.attributes.push(...group.attributes));
    this.columns.splice(this.columns.length - 2, 0, ...this.attributes.map(a => '' + a.id));

  }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
      this.sortTableData((sortState));
    }

    editCostsPrice(price: Price) {
      this.editCostsPriceFunction(price);
    }

    removeCostsPrice(price: Price) {
      this.removeCostsPriceFunction(price);
    }

  private sortTableData(sort: Sort) {
    const sortColumn = sort.active;
    const sortOrder = sort.direction === 'desc' ? -1 : 1;
    if (sortColumn === 'valid-from') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ValidFrom = r1.validPeriod?.from != null ? r1.validPeriod?.from?.getTime() : 0;
          const r2ValidFrom = r2.validPeriod?.from != null ? r2.validPeriod?.from?.getTime() : 0;
          console.log('sortresult', r1ValidFrom, r2ValidFrom, (r1ValidFrom - r2ValidFrom) * sortOrder);
          return (r1ValidFrom - r2ValidFrom) * sortOrder;
        });
    } else if (sortColumn === 'valid-until') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ValidUntil = r1.validPeriod?.until != null ? r1.validPeriod?.until?.getTime() : 0;
          const r2ValidUntil = r2.validPeriod?.until != null ? r2.validPeriod?.until?.getTime() : 0;
          return (r1ValidUntil - r2ValidUntil) * sortOrder;
        });
    } else if (sortColumn === 'price-net') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1PriceNet = r1.priceNet != null ? r1.priceNet : 0;
          const r2PriceNet = r2.priceNet != null ? r2.priceNet : 0;
          return (r1PriceNet - r2PriceNet) * sortOrder;
        });
    } else if (sortColumn === 'tax-rate') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1TaxRate = r1.taxRate != null ? r1.taxRate : 0;
          const r2TaxRate = r2.taxRate != null ? r2.taxRate : 0;
          return (r1TaxRate - r2TaxRate) * sortOrder;
        });
    } else if (sortColumn === 'price-vat') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1PriceVat = r1.priceVat != null ? r1.priceVat : 0;
          const r2PriceVat = r2.priceVat != null ? r2.priceVat : 0;
          return (r1PriceVat - r2PriceVat) * sortOrder;
        });
    } else if (sortColumn === 'reference-date') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1ReferenceDate = r1.referenceDate != null ? r1.referenceDate : '';
          const r2ReferenceDate = r2.referenceDate != null ? r2.referenceDate : '';
          return r1ReferenceDate.localeCompare(r2ReferenceDate) * sortOrder;
        });
    } else if (sortColumn === 'source') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1Source = r1.source != null ? r1.source : '';
          const r2Source = r2.source != null ? r2.source : '';
          return r1Source.localeCompare(r2Source) * sortOrder;
        });
    } else if (sortColumn === 'source') {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1Source = r1.source != null ? r1.source : '';
          const r2Source = r2.source != null ? r2.source : '';
          return r1Source.localeCompare(r2Source) * sortOrder;
        });
    } else if (sortColumn === this.taxRateColumn) {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1Source = r1.taxRate != null ? r1.taxRate : 0;
          const r2Source = r2.taxRate != null ? r2.taxRate : 0;
          return (r1Source - r2Source) * sortOrder;
        });
    } else if (sortColumn === this.vatColumn) {
      this.datasource.data  =
        this.datasource.data.sort( (r1,r2) => {
          const r1Source = r1.priceVat != null ? r1.priceVat : 0;
          const r2Source = r2.priceVat != null ? r2.priceVat : 0;
          return (r1Source - r2Source) * sortOrder;
        });
    }

  }
}
